import { useEffect, useState } from "react";
import { Store } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { loadPlatformInfo, onBrand } from "@/lib/brand";

// null enquanto carrega, "" sem logo.
function useLogo() {
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    let on = true;
    loadPlatformInfo().then((d) => { if (on) setLogo(d.logo_url || ""); });
    const off = onBrand(setLogo);
    return () => { on = false; off(); };
  }, []);
  return logo;
}

export function BrandMark({ size = "h-10 w-10", tone = "bg-blue-500", testId = "brand-mark" }) {
  const logo = useLogo();
  const [broken, setBroken] = useState("");
  const height = size.split(" ")[0];
  if (logo === null) return <span className={`${size} shrink-0`} />;
  if (logo && broken !== logo) {
    return <img src={imgUrl(logo)} alt="Logo FSCsistemas" onError={() => setBroken(logo)} className={`${height} w-auto max-w-[10rem] shrink-0 rounded-xl object-contain`} data-testid={`${testId}-logo`} />;
  }
  return <span className={`grid ${size} shrink-0 place-items-center rounded-xl ${tone}`} data-testid={`${testId}-icon`}><Store className="h-5 w-5" /></span>;
}
